import React from 'react'
import DeveloperRouter from './Router'

const DeveloperPage = (): React.ReactElement => <DeveloperRouter />

export default DeveloperPage
